export default "__VITE_ASSET__C42VZkCU__"